export default "__VITE_ASSET__246c5ea8__"